import { render, staticRenderFns } from "./FacilityModal.vue?vue&type=template&id=b60a0fc6&scoped=true&"
import script from "./FacilityModal.vue?vue&type=script&lang=js&"
export * from "./FacilityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60a0fc6",
  null
  
)

export default component.exports